// Translations for Georg Esco Artist Website
// Languages: French, English, Chinese, Japanese, Spanish, Romanian

export const translations = {
  fr: {
    // Navigation
    nav: {
      home: "Accueil",
      biography: "Biographie",
      galleries: "Galeries",
      shop: "Boutique",
      press: "Presse",
      contact: "Contact"
    },
    // Hero Section
    hero: {
      subtitle: "Artiste-peintre franco-roumain",
      scrollText: "Découvrir",
      awardBadge: "Peintre Primé"
    },
    // Biography
    bio: {
      title: "Biographie",
      text1: "Georg Esco, artiste-peintre franco-roumain né le 11 mars 1977 à Brașov en Transylvanie, a rapidement attiré l'attention des milieux politique et culturel parisiens dans les années 1990.",
      text2: "En 1997, il réalise sa première exposition, à la Cité Universitaire Internationale, à Paris, où il s'installe définitivement la même année.",
      text3: "Malgré cette reconnaissance précoce, la majeure partie de son œuvre est restée jusqu'à présent dans l'ombre. Après avoir passé des années à créer en silence, Esco s'apprête aujourd'hui à dévoiler pour la première fois des centaines de toiles jusque-là jamais exposées.",
      text4: "Ces œuvres, empreintes de sa sensibilité unique, témoignent de sa vision du monde, où se mêlent des thèmes aussi puissants que la guerre, l'exil et l'érotisme.",
      text5: "Son style oscille constamment entre l'abstraction, avec des toiles où les couleurs flambent comme une urgence passionnée, et des compositions plus sombres où la lumière surgit subtilement.",
      text6: "Esco capte cette tension entre le chaos et l'harmonie, ce battement perpétuel entre l'intérieur et l'extérieur, où l'Art devient une réponse face aux bouleversements du monde.",
      prizeA: "Lauréat du Prix A - République Socialiste du Vietnam (2025)",
      photoCaption: "Roumanie, années d'enfance"
    },
    // Galleries
    galleries: {
      title: "Galeries",
      portraits: "Portraits",
      portraitsDesc: "Figures historiques et personnalités marquantes",
      landscapes: "Paysages et Nature Morte",
      landscapesDesc: "Une exploration de la nature et de la vie quotidienne",
      genesis: "Genèse de la Vie",
      genesisDesc: "La naissance, l'origine, le commencement",
      grids: "Quadrillages",
      gridsDesc: "Structures géométriques et abstractions",
      eroticism: "Érotisme",
      eroticismDesc: "L'amour et la rencontre des corps",
      universe: "L'Univers",
      universeDesc: "Exploration cosmique et spirituelle",
      pollock: "La Renaissance de Pollock",
      pollockDesc: "Hommage et réinterprétation",
      pollockCubism: "Pollock et le Cubisme",
      pollockCubismDesc: "Rencontre entre deux mouvements",
      history: "Traces de l'Histoire",
      historyDesc: "Guerre, mémoire et témoignage",
      pantheon: "Genèse dans Panthéon",
      pantheonDesc: "Résonances et fragments",
      sacred: "Émergence du Sacré",
      sacredDesc: "Chronique d'une création",
      lines: "Entre les Lignes",
      linesDesc: "L'espace entre les mots et les formes",
      viewGallery: "Voir la galerie"
    },
    // Press
    press: {
      title: "Presse",
      subtitle: "Couverture médiatique internationale",
      readMore: "Lire l'article"
    },
    // Contact
    contact: {
      title: "Contact",
      subtitle: "Pour toute demande d'information ou collaboration",
      name: "Nom",
      email: "Email",
      subject: "Sujet",
      message: "Message",
      send: "Envoyer",
      success: "Message envoyé avec succès !",
      error: "Erreur lors de l'envoi du message."
    },
    // Footer
    footer: {
      rights: "Tous droits réservés",
      followMe: "Suivez-moi"
    },
    // Techniques
    techniques: {
      paintingOnCanvas: "Peinture sur toile",
      oilAndAcrylicOnCanvas: "Huile et acrylique sur toile"
    },
    // Copyright
    copyright: {
      paintingBy: "Peinture par Georg Esco",
      uniqueWork: "Œuvre originale unique - Reproduction interdite"
    },
    // Haute Galerie / Shop
    shop: {
      title: "Haute Galerie",
      subtitle: "Collection Exclusive de Georg Esco",
      collectionI: "Collection I",
      collectionITitle: "Grands Formats — Œuvres de Prestige",
      collectionIDesc: "Œuvres monumentales de plus de 60 cm",
      collectionII: "Collection II",
      collectionIITitle: "Formats Intermédiaires — Série Signature",
      collectionIIDesc: "Œuvres de 45 à 59 cm",
      collectionIII: "Collection III",
      collectionIIITitle: "Petits Formats — Série Fragments",
      collectionIIIDesc: "Œuvres intimistes de moins de 44 cm",
      viewCollection: "Découvrir la collection",
      backToCollections: "Retour aux collections",
      artworkDetails: "Détails de l'œuvre",
      dimensions: "Dimensions",
      price: "Prix",
      technique: "Technique",
      legalMention: "Acrylique sur toile, livrée sans châssis ni cadre",
      copyright: "© Georg Esco - Reproduction interdite",
      secureShipping: "Expédition sécurisée",
      certificateOfAuthenticity: "Certificat d'authenticité",
      acquisitionButton: "Entrer en possession de cette œuvre",
      hoverToZoom: "Survolez pour zoomer",
      artworksCount: "œuvres",
      priceFrom: "À partir de",
      contactArtist: "Merci de contacter l'artiste directement"
    }
  },
  en: {
    nav: {
      home: "Home",
      biography: "Biography",
      galleries: "Galleries",
      shop: "Gallery Shop",
      press: "Press",
      contact: "Contact"
    },
    hero: {
      subtitle: "Franco-Romanian Painter",
      scrollText: "Discover",
      awardBadge: "Award Winning Painter"
    },
    bio: {
      title: "Biography",
      text1: "Georg Esco, Franco-Romanian painter born on March 11, 1977 in Brașov, Transylvania, quickly attracted the attention of Parisian political and cultural circles in the 1990s.",
      text2: "In 1997, he held his first exhibition at the Cité Universitaire Internationale in Paris, where he permanently settled the same year.",
      text3: "Despite this early recognition, most of his work has remained in the shadows until now. After years of creating in silence, Esco is now preparing to unveil for the first time hundreds of canvases never before exhibited.",
      text4: "These works, imbued with his unique sensitivity, reflect his vision of the world, where powerful themes such as war, exile and eroticism intertwine.",
      text5: "His style constantly oscillates between abstraction, with canvases where colors blaze like passionate urgency, and darker compositions where light subtly emerges.",
      text6: "Esco captures this tension between chaos and harmony, this perpetual beat between interior and exterior, where Art becomes a response to the upheavals of the world.",
      prizeA: "Laureate of Prix A - Socialist Republic of Vietnam (2025)",
      photoCaption: "Romania, childhood years"
    },
    galleries: {
      title: "Galleries",
      portraits: "Portraits",
      portraitsDesc: "Historical figures and notable personalities",
      landscapes: "Landscapes and Still Life",
      landscapesDesc: "An exploration of nature and daily life",
      genesis: "Genesis of Life",
      genesisDesc: "Birth, origin, beginning",
      grids: "Grids",
      gridsDesc: "Geometric structures and abstractions",
      eroticism: "Eroticism",
      eroticismDesc: "Love and the meeting of bodies",
      universe: "The Universe",
      universeDesc: "Cosmic and spiritual exploration",
      pollock: "The Renaissance of Pollock",
      pollockDesc: "Tribute and reinterpretation",
      pollockCubism: "Pollock and Cubism",
      pollockCubismDesc: "Meeting between two movements",
      history: "Traces of History",
      historyDesc: "War, memory and testimony",
      pantheon: "Genesis in Pantheon",
      pantheonDesc: "Resonances and fragments",
      sacred: "Emergence of the Sacred",
      sacredDesc: "Chronicle of a creation",
      lines: "Between the Lines",
      linesDesc: "The space between words and forms",
      viewGallery: "View gallery"
    },
    press: {
      title: "Press",
      subtitle: "International media coverage",
      readMore: "Read article"
    },
    contact: {
      title: "Contact",
      subtitle: "For any information request or collaboration",
      name: "Name",
      email: "Email",
      subject: "Subject",
      message: "Message",
      send: "Send",
      success: "Message sent successfully!",
      error: "Error sending message."
    },
    footer: {
      rights: "All rights reserved",
      followMe: "Follow me"
    },
    techniques: {
      paintingOnCanvas: "Painting on canvas",
      oilAndAcrylicOnCanvas: "Oil and acrylic on canvas"
    },
    copyright: {
      paintingBy: "Painting by Georg Esco",
      uniqueWork: "Unique original artwork - Reproduction prohibited"
    },
    shop: {
      title: "High Gallery",
      subtitle: "Exclusive Collection by Georg Esco",
      collectionI: "Collection I",
      collectionITitle: "Large Formats — Prestige Works",
      collectionIDesc: "Monumental works over 60 cm",
      collectionII: "Collection II",
      collectionIITitle: "Intermediate Formats — Signature Series",
      collectionIIDesc: "Works from 45 to 59 cm",
      collectionIII: "Collection III",
      collectionIIITitle: "Small Formats — Fragments Series",
      collectionIIIDesc: "Intimate works under 44 cm",
      viewCollection: "View collection",
      backToCollections: "Back to collections",
      artworkDetails: "Artwork details",
      dimensions: "Dimensions",
      price: "Price",
      technique: "Technique",
      legalMention: "Acrylic on canvas, delivered without stretcher or frame",
      copyright: "© Georg Esco - Reproduction prohibited",
      secureShipping: "Secure shipping",
      certificateOfAuthenticity: "Certificate of authenticity",
      acquisitionButton: "Acquisition request",
      hoverToZoom: "Hover to zoom",
      artworksCount: "artworks",
      priceFrom: "From",
      contactArtist: "Please contact the artist directly"
    }
  },
  zh: {
    nav: {
      home: "首页",
      biography: "传记",
      galleries: "画廊",
      shop: "艺术商店",
      press: "媒体",
      contact: "联系"
    },
    hero: {
      subtitle: "法裔罗马尼亚画家",
      scrollText: "探索",
      awardBadge: "A奖 - 越南 2025"
    },
    bio: {
      title: "传记",
      text1: "Georg Esco，法裔罗马尼亚画家，1977年3月11日出生于特兰西瓦尼亚的布拉索夫，在1990年代迅速引起了巴黎政治和文化界的关注。",
      text2: "1997年，他在巴黎国际大学城举办了首次展览，并于同年永久定居于此。",
      text3: "尽管早期获得认可，但他的大部分作品至今一直处于阴影之中。经过多年默默创作，Esco现在准备首次展出数百幅从未展出过的画作。",
      text4: "这些作品充满了他独特的敏感性，反映了他对世界的愿景，其中交织着战争、流亡和情欲等强大主题。",
      text5: "他的风格在抽象与更黑暗的构图之间不断摇摆，画布上的色彩如同激情的紧迫感般燃烧，而光线则微妙地浮现。",
      text6: "Esco捕捉了混沌与和谐之间的张力，内在与外在之间的永恒跳动，艺术成为对世界动荡的回应。",
      prizeA: "越南社会主义共和国A级奖获得者（2025年）",
      photoCaption: "罗马尼亚，童年岁月"
    },
    galleries: {
      title: "画廊",
      portraits: "肖像",
      portraitsDesc: "历史人物和杰出人物",
      landscapes: "风景与静物",
      landscapesDesc: "对自然和日常生活的探索",
      genesis: "生命起源",
      genesisDesc: "诞生、起源、开始",
      grids: "网格",
      gridsDesc: "几何结构和抽象",
      eroticism: "情欲",
      eroticismDesc: "爱与身体的相遇",
      universe: "宇宙",
      universeDesc: "宇宙和精神探索",
      pollock: "波洛克的复兴",
      pollockDesc: "致敬与重新诠释",
      pollockCubism: "波洛克与立体主义",
      pollockCubismDesc: "两种运动的相遇",
      history: "历史痕迹",
      historyDesc: "战争、记忆和见证",
      pantheon: "万神殿中的创世",
      pantheonDesc: "共鸣与片段",
      sacred: "神圣的涌现",
      sacredDesc: "创造纪事",
      lines: "字里行间",
      linesDesc: "文字和形式之间的空间",
      viewGallery: "查看画廊"
    },
    press: {
      title: "媒体",
      subtitle: "国际媒体报道",
      readMore: "阅读文章"
    },
    contact: {
      title: "联系",
      subtitle: "如需任何信息或合作",
      name: "姓名",
      email: "电子邮件",
      subject: "主题",
      message: "消息",
      send: "发送",
      success: "消息发送成功！",
      error: "发送消息时出错。"
    },
    footer: {
      rights: "版权所有",
      followMe: "关注我"
    },
    techniques: {
      paintingOnCanvas: "布面绘画",
      oilAndAcrylicOnCanvas: "布面油画和丙烯"
    },
    copyright: {
      paintingBy: "Georg Esco 绘画",
      uniqueWork: "独一无二的原创作品 - 禁止复制"
    },
    shop: {
      title: "高级画廊",
      subtitle: "Georg Esco 独家收藏",
      collectionI: "系列 I",
      collectionITitle: "大幅面 — 威望作品",
      collectionIDesc: "超过60厘米的纪念性作品",
      collectionII: "系列 II",
      collectionIITitle: "中等幅面 — 签名系列",
      collectionIIDesc: "45至59厘米的作品",
      collectionIII: "系列 III",
      collectionIIITitle: "小幅面 — 片段系列",
      collectionIIIDesc: "44厘米以下的亲密作品",
      viewCollection: "查看收藏",
      backToCollections: "返回收藏",
      artworkDetails: "作品详情",
      dimensions: "尺寸",
      price: "价格",
      technique: "技术",
      legalMention: "帆布上的丙烯画，不带担架或框架交付",
      copyright: "© Georg Esco - 禁止复制",
      secureShipping: "安全运输",
      certificateOfAuthenticity: "真品证书",
      acquisitionButton: "收购请求",
      hoverToZoom: "悬停以放大",
      artworksCount: "作品",
      priceFrom: "起价",
      contactArtist: "请直接联系艺术家"
    }
  },
  ja: {
    nav: {
      home: "ホーム",
      biography: "略歴",
      galleries: "ギャラリー",
      shop: "ギャラリーショップ",
      press: "プレス",
      contact: "お問い合わせ"
    },
    hero: {
      subtitle: "フランス系ルーマニア人画家",
      scrollText: "探索する",
      awardBadge: "A賞 - ベトナム 2025"
    },
    bio: {
      title: "略歴",
      text1: "Georg Esco、フランス系ルーマニア人画家、1977年3月11日トランシルヴァニアのブラショフに生まれ、1990年代にパリの政治・文化界の注目を集めました。",
      text2: "1997年、パリの国際大学都市で初の展覧会を開催し、同年に永住しました。",
      text3: "この早期の認知にもかかわらず、彼の作品の大部分は今まで影に隠れていました。何年も静かに創作を続けた後、Escoは今、これまで展示されたことのない数百枚のキャンバスを初めて公開する準備をしています。",
      text4: "これらの作品は、彼独自の感性に満ち、戦争、亡命、エロティシズムなどの強力なテーマが絡み合う世界観を反映しています。",
      text5: "彼のスタイルは、情熱的な緊急性のように色彩が燃え上がる抽象と、光が微妙に浮かび上がるより暗い構成の間で常に揺れ動いています。",
      text6: "Escoは、混沌と調和の間の緊張、内と外の間の永遠の鼓動を捉え、芸術が世界の激動への応答となります。",
      prizeA: "ベトナム社会主義共和国A賞受賞者（2025年）",
      photoCaption: "ルーマニア、幼少期"
    },
    galleries: {
      title: "ギャラリー",
      portraits: "肖像画",
      portraitsDesc: "歴史的人物と著名人",
      landscapes: "風景画と静物画",
      landscapesDesc: "自然と日常生活の探求",
      genesis: "生命の起源",
      genesisDesc: "誕生、起源、始まり",
      grids: "グリッド",
      gridsDesc: "幾何学的構造と抽象",
      eroticism: "エロティシズム",
      eroticismDesc: "愛と身体の出会い",
      universe: "宇宙",
      universeDesc: "宇宙的・精神的探求",
      pollock: "ポロックの復活",
      pollockDesc: "オマージュと再解釈",
      pollockCubism: "ポロックとキュビズム",
      pollockCubismDesc: "二つの運動の出会い",
      history: "歴史の痕跡",
      historyDesc: "戦争、記憶、証言",
      pantheon: "パンテオンの創世記",
      pantheonDesc: "響きと断片",
      sacred: "聖なるものの出現",
      sacredDesc: "創造の記録",
      lines: "行間に",
      linesDesc: "言葉と形の間の空間",
      viewGallery: "ギャラリーを見る"
    },
    press: {
      title: "プレス",
      subtitle: "国際メディア報道",
      readMore: "記事を読む"
    },
    contact: {
      title: "お問い合わせ",
      subtitle: "情報のご要望やコラボレーションについて",
      name: "お名前",
      email: "メール",
      subject: "件名",
      message: "メッセージ",
      send: "送信",
      success: "メッセージが正常に送信されました！",
      error: "メッセージの送信中にエラーが発生しました。"
    },
    footer: {
      rights: "全著作権所有",
      followMe: "フォローする"
    },
    techniques: {
      paintingOnCanvas: "キャンバスに絵画",
      oilAndAcrylicOnCanvas: "キャンバスに油彩とアクリル"
    },
    copyright: {
      paintingBy: "Georg Esco による絵画",
      uniqueWork: "唯一無二のオリジナル作品 - 複製禁止"
    },
    shop: {
      title: "ハイギャラリー",
      subtitle: "Georg Esco エクスクルーシブコレクション",
      collectionI: "コレクション I",
      collectionITitle: "大型フォーマット — プレステージ作品",
      collectionIDesc: "60cm以上の記念碑的作品",
      collectionII: "コレクション II",
      collectionIITitle: "中間フォーマット — シグネチャーシリーズ",
      collectionIIDesc: "45〜59cmの作品",
      collectionIII: "コレクション III",
      collectionIIITitle: "小型フォーマット — フラグメントシリーズ",
      collectionIIIDesc: "44cm未満の親密な作品",
      viewCollection: "コレクションを見る",
      backToCollections: "コレクションに戻る",
      artworkDetails: "作品詳細",
      dimensions: "寸法",
      price: "価格",
      technique: "技術",
      legalMention: "キャンバスにアクリル、ストレッチャーやフレームなしで配送",
      copyright: "© Georg Esco - 複製禁止",
      secureShipping: "安全な配送",
      certificateOfAuthenticity: "真正性証明書",
      acquisitionButton: "取得リクエスト",
      hoverToZoom: "ホバーしてズーム",
      artworksCount: "作品",
      priceFrom: "から",
      contactArtist: "アーティストに直接お問い合わせください"
    }
  },
  es: {
    nav: {
      home: "Inicio",
      biography: "Biografía",
      galleries: "Galerías",
      shop: "Tienda Galería",
      press: "Prensa",
      contact: "Contacto"
    },
    hero: {
      subtitle: "Pintor franco-rumano",
      scrollText: "Descubrir",
      awardBadge: "Premio A - Vietnam 2025"
    },
    bio: {
      title: "Biografía",
      text1: "Georg Esco, pintor franco-rumano nacido el 11 de marzo de 1977 en Brașov, Transilvania, atrajo rápidamente la atención de los círculos políticos y culturales parisinos en los años 1990.",
      text2: "En 1997, realizó su primera exposición en la Cité Universitaire Internationale de París, donde se instaló definitivamente el mismo año.",
      text3: "A pesar de este reconocimiento temprano, la mayor parte de su obra ha permanecido en la sombra hasta ahora. Después de años creando en silencio, Esco se prepara ahora para revelar por primera vez cientos de lienzos nunca antes expuestos.",
      text4: "Estas obras, impregnadas de su sensibilidad única, reflejan su visión del mundo, donde se entrelazan temas tan poderosos como la guerra, el exilio y el erotismo.",
      text5: "Su estilo oscila constantemente entre la abstracción, con lienzos donde los colores arden como urgencia apasionada, y composiciones más oscuras donde la luz surge sutilmente.",
      text6: "Esco captura esta tensión entre el caos y la armonía, este latido perpetuo entre el interior y el exterior, donde el Arte se convierte en una respuesta a las convulsiones del mundo.",
      prizeA: "Laureado del Premio A - República Socialista de Vietnam (2025)",
      photoCaption: "Rumanía, años de infancia"
    },
    galleries: {
      title: "Galerías",
      portraits: "Retratos",
      portraitsDesc: "Figuras históricas y personalidades destacadas",
      landscapes: "Paisajes y Naturaleza Muerta",
      landscapesDesc: "Una exploración de la naturaleza y la vida cotidiana",
      genesis: "Génesis de la Vida",
      genesisDesc: "Nacimiento, origen, comienzo",
      grids: "Cuadrículas",
      gridsDesc: "Estructuras geométricas y abstracciones",
      eroticism: "Erotismo",
      eroticismDesc: "El amor y el encuentro de los cuerpos",
      universe: "El Universo",
      universeDesc: "Exploración cósmica y espiritual",
      pollock: "El Renacimiento de Pollock",
      pollockDesc: "Homenaje y reinterpretación",
      pollockCubism: "Pollock y el Cubismo",
      pollockCubismDesc: "Encuentro entre dos movimientos",
      history: "Huellas de la Historia",
      historyDesc: "Guerra, memoria y testimonio",
      pantheon: "Génesis en Panteón",
      pantheonDesc: "Resonancias y fragmentos",
      sacred: "Emergencia de lo Sagrado",
      sacredDesc: "Crónica de una creación",
      lines: "Entre Líneas",
      linesDesc: "El espacio entre palabras y formas",
      viewGallery: "Ver galería"
    },
    press: {
      title: "Prensa",
      subtitle: "Cobertura mediática internacional",
      readMore: "Leer artículo"
    },
    contact: {
      title: "Contacto",
      subtitle: "Para cualquier solicitud de información o colaboración",
      name: "Nombre",
      email: "Correo electrónico",
      subject: "Asunto",
      message: "Mensaje",
      send: "Enviar",
      success: "¡Mensaje enviado con éxito!",
      error: "Error al enviar el mensaje."
    },
    footer: {
      rights: "Todos los derechos reservados",
      followMe: "Sígueme"
    },
    techniques: {
      paintingOnCanvas: "Pintura sobre lienzo",
      oilAndAcrylicOnCanvas: "Óleo y acrílico sobre lienzo"
    },
    copyright: {
      paintingBy: "Pintura de Georg Esco",
      uniqueWork: "Obra original única - Reproducción prohibida"
    },
    shop: {
      title: "Galería Alta",
      subtitle: "Colección Exclusiva de Georg Esco",
      collectionI: "Colección I",
      collectionITitle: "Grandes Formatos — Obras de Prestigio",
      collectionIDesc: "Obras monumentales de más de 60 cm",
      collectionII: "Colección II",
      collectionIITitle: "Formatos Intermedios — Serie Firma",
      collectionIIDesc: "Obras de 45 a 59 cm",
      collectionIII: "Colección III",
      collectionIIITitle: "Pequeños Formatos — Serie Fragmentos",
      collectionIIIDesc: "Obras íntimas de menos de 44 cm",
      viewCollection: "Ver colección",
      backToCollections: "Volver a colecciones",
      artworkDetails: "Detalles de la obra",
      dimensions: "Dimensiones",
      price: "Precio",
      technique: "Técnica",
      legalMention: "Acrílico sobre lienzo, entregado sin bastidor ni marco",
      copyright: "© Georg Esco - Reproducción prohibida",
      secureShipping: "Envío seguro",
      certificateOfAuthenticity: "Certificado de autenticidad",
      acquisitionButton: "Solicitud de adquisición",
      hoverToZoom: "Pase el cursor para ampliar",
      artworksCount: "obras",
      priceFrom: "Desde",
      contactArtist: "Por favor contacte directamente al artista"
    }
  },
  ro: {
    nav: {
      home: "Acasă",
      biography: "Biografie",
      galleries: "Galerii",
      shop: "Magazin Galerie",
      press: "Presă",
      contact: "Contact"
    },
    hero: {
      subtitle: "Pictor franco-român",
      scrollText: "Descoperă",
      awardBadge: "Premiul A - Vietnam 2025"
    },
    bio: {
      title: "Biografie",
      text1: "Georg Esco, pictor franco-român născut pe 11 martie 1977 în Brașov, Transilvania, a atras rapid atenția cercurilor politice și culturale pariziene în anii 1990.",
      text2: "În 1997, a realizat prima sa expoziție la Cité Universitaire Internationale din Paris, unde s-a stabilit definitiv în același an.",
      text3: "În ciuda acestei recunoașteri timpurii, cea mai mare parte a operei sale a rămas până acum în umbră. După ce a petrecut ani de zile creând în tăcere, Esco se pregătește acum să dezvăluie pentru prima dată sute de pânze niciodată expuse până acum.",
      text4: "Aceste lucrări, marcate de sensibilitatea sa unică, mărturisesc viziunea sa asupra lumii, unde se îmbină teme atât de puternice precum războiul, exilul și erotismul.",
      text5: "Stilul său oscilează constant între abstracție, cu pânze unde culorile ard ca o urgență pasională, și compoziții mai întunecate unde lumina apare subtil.",
      text6: "Esco surprinde această tensiune între haos și armonie, această bătaie perpetuă între interior și exterior, unde Arta devine un răspuns în fața tulburărilor lumii.",
      prizeA: "Laureat al Premiului A - Republica Socialistă Vietnam (2025)",
      photoCaption: "România, anii copilăriei"
    },
    galleries: {
      title: "Galerii",
      portraits: "Portrete",
      portraitsDesc: "Figuri istorice și personalități marcante",
      landscapes: "Peisaje și Natură Moartă",
      landscapesDesc: "O explorare a naturii și vieții cotidiene",
      genesis: "Geneza Vieții",
      genesisDesc: "Nașterea, originea, începutul",
      grids: "Caroiaje",
      gridsDesc: "Structuri geometrice și abstracții",
      eroticism: "Erotism",
      eroticismDesc: "Dragostea și întâlnirea corpurilor",
      universe: "Universul",
      universeDesc: "Explorare cosmică și spirituală",
      pollock: "Renașterea lui Pollock",
      pollockDesc: "Omagiu și reinterpretare",
      pollockCubism: "Pollock și Cubismul",
      pollockCubismDesc: "Întâlnirea dintre două mișcări",
      history: "Urmele Istoriei",
      historyDesc: "Război, memorie și mărturie",
      pantheon: "Geneza în Panteon",
      pantheonDesc: "Rezonanțe și fragmente",
      sacred: "Emergența Sacrului",
      sacredDesc: "Cronica unei creații",
      lines: "Între Linii",
      linesDesc: "Spațiul dintre cuvinte și forme",
      viewGallery: "Vezi galeria"
    },
    press: {
      title: "Presă",
      subtitle: "Acoperire mediatică internațională",
      readMore: "Citește articolul"
    },
    contact: {
      title: "Contact",
      subtitle: "Pentru orice cerere de informații sau colaborare",
      name: "Nume",
      email: "Email",
      subject: "Subiect",
      message: "Mesaj",
      send: "Trimite",
      success: "Mesaj trimis cu succes!",
      error: "Eroare la trimiterea mesajului."
    },
    footer: {
      rights: "Toate drepturile rezervate",
      followMe: "Urmărește-mă"
    },
    techniques: {
      paintingOnCanvas: "Pictură pe pânză",
      oilAndAcrylicOnCanvas: "Ulei și acrilic pe pânză"
    },
    copyright: {
      paintingBy: "Pictură de Georg Esco",
      uniqueWork: "Operă originală unică - Reproducere interzisă"
    },
    shop: {
      title: "Galeria Înaltă",
      subtitle: "Colecție Exclusivă de Georg Esco",
      collectionI: "Colecția I",
      collectionITitle: "Formate Mari — Lucrări de Prestigiu",
      collectionIDesc: "Lucrări monumentale peste 60 cm",
      collectionII: "Colecția II",
      collectionIITitle: "Formate Intermediare — Seria Semnătură",
      collectionIIDesc: "Lucrări de la 45 la 59 cm",
      collectionIII: "Colecția III",
      collectionIIITitle: "Formate Mici — Seria Fragmente",
      collectionIIIDesc: "Lucrări intime sub 44 cm",
      viewCollection: "Vezi colecția",
      backToCollections: "Înapoi la colecții",
      artworkDetails: "Detalii operă",
      dimensions: "Dimensiuni",
      price: "Preț",
      technique: "Tehnică",
      legalMention: "Acrilic pe pânză, livrat fără ramă sau șasiu",
      copyright: "© Georg Esco - Reproducere interzisă",
      secureShipping: "Livrare securizată",
      certificateOfAuthenticity: "Certificat de autenticitate",
      acquisitionButton: "Cerere de achiziție",
      hoverToZoom: "Treceți cursorul pentru a mări",
      artworksCount: "lucrări",
      priceFrom: "De la",
      contactArtist: "Vă rugăm să contactați direct artistul"
    }
  },
  ar: {
    // Navigation
    nav: {
      home: "الصفحة الرئيسية",
      biography: "السيرة الذاتية",
      galleries: "المعارض",
      shop: "المتجر",
      press: "الصحافة",
      contact: "اتصل"
    },
    // Hero Section
    hero: {
      subtitle: "فنان تشكيلي فرنسي-روماني",
      scrollText: "اكتشف",
      awardBadge: "فنان حائز على جوائز"
    },
    // Biography
    bio: {
      title: "السيرة الذاتية",
      text1: "جورج إسكو، فنان تشكيلي فرنسي-روماني ولد في 11 مارس 1977 في براشوف، ترانسيلفانيا، جذب انتباه الدوائر السياسية والثقافية الباريسية في التسعينيات.",
      text2: "في عام 1997، أقام معرضه الأول في المدينة الجامعية الدولية في باريس، حيث استقر نهائياً في نفس العام.",
      text3: "على الرغم من هذا الاعتراف المبكر، ظلت معظم أعماله حتى الآن في الظل. بعد سنوات من الإبداع في صمت، يستعد إسكو اليوم للكشف لأول مرة عن مئات اللوحات التي لم تُعرض من قبل.",
      text4: "هذه الأعمال، المفعمة بحساسيته الفريدة، تشهد على رؤيته للعالم، حيث تمتزج موضوعات قوية مثل الحرب والمنفى والإيروتيكية.",
      text5: "يتأرجح أسلوبه باستمرار بين التجريد، مع لوحات تتوهج فيها الألوان كإلحاح عاطفي، وتركيبات أكثر ظلمة حيث يظهر الضوء بشكل خفي.",
      text6: "يلتقط إسكو هذا التوتر بين الفوضى والانسجام، هذا النبض الدائم بين الداخل والخارج، حيث يصبح الفن إجابة على اضطرابات العالم.",
      prizeA: "حائز على جائزة أ - جمهورية فيتنام الاشتراكية (2025)",
      photoCaption: "رومانيا، سنوات الطفولة"
    },
    // Galleries
    galleries: {
      title: "المعارض",
      portraits: "صور شخصية",
      portraitsDesc: "شخصيات تاريخية وشخصيات بارزة",
      landscapes: "مناظر طبيعية وطبيعة صامتة",
      landscapesDesc: "استكشاف للطبيعة والحياة اليومية",
      genesis: "نشأة الحياة",
      genesisDesc: "الولادة، الأصل، البداية",
      grids: "شبكات",
      gridsDesc: "هياكل هندسية وتجريدات",
      eroticism: "إيروتيكية",
      eroticismDesc: "الحب ولقاء الأجساد",
      universe: "الكون",
      universeDesc: "استكشاف كوني وروحي",
      pollock: "نهضة بولوك",
      pollockDesc: "تكريم وإعادة تفسير",
      pollockCubism: "بولوك والتكعيبية",
      pollockCubismDesc: "لقاء بين حركتين",
      pollockFauvism: "بولوك والوحشية",
      pollockFauvismDesc: "ألوان متفجرة وطاقة نقية",
      war: "الحرب",
      warDesc: "الفوضى والدمار والأمل",
      history: "آثار التاريخ",
      historyDesc: "الحرب والذاكرة والشهادة",
      pantheon: "نشأة في البانثيون",
      pantheonDesc: "أصداء وشظايا",
      sacred: "ظهور المقدس",
      sacredDesc: "سجل الخلق",
      lines: "بين السطور",
      linesDesc: "المساحة بين الكلمات والأشكال",
      viewGallery: "عرض المعرض"
    },
    // Shop (Haute Galerie)
    shop: {
      title: "معرض الفن الراقي",
      subtitle: "100 عمل أصلي : استثمار فني فاخر",
      searchPlaceholder: "ابحث عن عمل...",
      sortBy: "ترتيب حسب",
      priceAsc: "السعر: من الأدنى إلى الأعلى",
      priceDesc: "السعر: من الأعلى إلى الأدنى",
      titleAsc: "العنوان: أ-ي",
      titleDesc: "العنوان: ي-أ",
      filterPrice: "تصفية حسب السعر",
      filterAll: "الكل",
      under1000: "أقل من 1000 يورو",
      range1000to3000: "1000 - 3000 يورو",
      range3000to5000: "3000 - 5000 يورو",
      above5000: "أكثر من 5000 يورو",
      artworkDetails: "تفاصيل العمل",
      dimensions: "الأبعاد",
      price: "السعر",
      collection: "مجموعة",
      acquisitionButton: "الدخول في حيازة هذا العمل",
      technique: "التقنية",
      legalMention: "أكريليك على قماش، يتم التسليم بدون إطار أو نقالة",
      copyright: "© Georg Esco - يحظر النسخ",
      secureShipping: "شحن آمن",
      certificateOfAuthenticity: "شهادة الأصالة",
      hoverToZoom: "مرر للتكبير",
      contactFormTitle: "طلب الاستحواذ",
      contactFormSubtitle: "املأ هذا النموذج للاستعلام عن هذا العمل الفني",
      name: "الاسم",
      email: "البريد الإلكتروني",
      phone: "الهاتف",
      message: "رسالتك",
      messagePlaceholder: "أود الاستفسار عن العمل...",
      send: "إرسال الطلب",
      closeModal: "إغلاق",
      artworksCount: "أعمال"
    },
    // Press
    press: {
      title: "الصحافة",
      article1Title: "معرض في المدينة الجامعية الدولية - باريس 1997",
      article1Desc: "المعرض الأول لجورج إسكو في باريس",
      article2Title: "لقاء مع Bérénice Levet - 2024",
      article2Desc: "مناقشة حول الفن المعاصر والفلسفة",
      article3Title: "جائزة أ - جمهورية فيتنام الاشتراكية 2025",
      article3Desc: "تكريم فني دولي"
    },
    // Contact
    contact: {
      title: "اتصل",
      subtitle: "للاستفسارات عن الأعمال أو التعاون",
      form: {
        name: "الاسم",
        email: "البريد الإلكتروني",
        phone: "الهاتف",
        message: "رسالتك",
        send: "إرسال",
        sending: "جارٍ الإرسال...",
        success: "تم إرسال رسالتك بنجاح!",
        error: "خطأ في الإرسال. حاول مرة أخرى."
      }
    },
    // Footer
    footer: {
      rights: "جميع الحقوق محفوظة",
      follow: "تابعنا"
    },
    // Common
    common: {
      loading: "جارٍ التحميل...",
      error: "خطأ",
      noResults: "لا توجد نتائج",
      close: "إغلاق",
      priceFrom: "ابتداءً من",
      contactArtist: "يرجى الاتصال بالفنان مباشرة"
    },
    // Techniques
    techniques: {
      paintingOnCanvas: "لوحة على قماش",
      oilAndAcrylicOnCanvas: "زيت وأكريليك على قماش"
    },
    // Copyright
    copyright: {
      paintingBy: "لوحة لجورج إسكو",
      uniqueWork: "عمل أصلي فريد - ممنوع النسخ"
    }
  },
  // Russian
  ru: {
    // Navigation
    nav: {
      home: "Главная",
      biography: "Биография",
      galleries: "Галереи",
      shop: "Магазин",
      press: "Пресса",
      contact: "Контакт"
    },
    // Hero Section
    hero: {
      subtitle: "Франко-румынский художник",
      scrollText: "Открыть",
      awardBadge: "Награжденный художник"
    },
    // Biography
    bio: {
      title: "Биография",
      text1: "Георг Эско, франко-румынский художник, родившийся 11 марта 1977 года в Брашове, Трансильвания, быстро привлек внимание парижских политических и культурных кругов в 1990-х годах.",
      text2: "В 1997 году он провел свою первую выставку в Международном университетском городке в Париже, где окончательно поселился в том же году.",
      text3: "Несмотря на это раннее признание, большая часть его работ до сих пор оставалась в тени. После многих лет молчаливого творчества Эско сейчас готовится впервые представить сотни никогда ранее не выставлявшихся картин.",
      text4: "Эти работы, наполненные его уникальной чувствительностью, свидетельствуют о его видении мира, где переплетаются такие мощные темы, как война, изгнание и эротизм.",
      text5: "Его стиль постоянно колеблется между абстракцией, с полотнами, где цвета пылают, как страстная срочность, и более темными композициями, где свет тонко проявляется.",
      text6: "Эско улавливает это напряжение между хаосом и гармонией, это вечное биение между внутренним и внешним, где искусство становится ответом на потрясения мира.",
      prizeA: "Лауреат премии A - Социалистическая Республика Вьетнам (2025)",
      photoCaption: "Румыния, детские годы"
    },
    // Galleries
    galleries: {
      title: "Галереи",
      portraits: "Портреты",
      portraitsDesc: "Исторические личности и выдающиеся персоны",
      landscapes: "Пейзажи и натюрморты",
      landscapesDesc: "Исследование природы и повседневной жизни",
      genesis: "Генезис жизни",
      genesisDesc: "Рождение, происхождение, начало",
      grids: "Решетки",
      gridsDesc: "Геометрические структуры и абстракции",
      eroticism: "Эротизм",
      eroticismDesc: "Любовь и встреча тел",
      universe: "Вселенная",
      universeDesc: "Космическое и духовное исследование",
      pollock: "Возрождение Поллока",
      pollockDesc: "Дань и переосмысление",
      pollockCubism: "Поллок и кубизм",
      pollockCubismDesc: "Встреча двух движений",
      pollockFauvism: "Поллок и фовизм",
      pollockFauvismDesc: "Взрывные цвета и чистая энергия",
      history: "Следы истории",
      historyDesc: "Война, память и свидетельство",
      war: "Война",
      warDesc: "Хаос, разрушение и надежда",
      pantheon: "Пантеон",
      pantheonDesc: "Резонансы и фрагменты",
      sacred: "Появление священного",
      sacredDesc: "Хроника творения",
      lines: "Между строк",
      linesDesc: "Пространство между словами и формами",
      viewGallery: "Посмотреть галерею"
    },
    // Press
    press: {
      title: "Пресса",
      subtitle: "Международное освещение в СМИ",
      readMore: "Читать статью"
    },
    // Contact
    contact: {
      title: "Контакт",
      subtitle: "По любым запросам информации или сотрудничества",
      name: "Имя",
      email: "Email",
      subject: "Тема",
      message: "Сообщение",
      send: "Отправить",
      sending: "Отправка...",
      success: "Сообщение успешно отправлено!",
      error: "Ошибка при отправке. Попробуйте еще раз."
    },
    // Footer
    footer: {
      rights: "Все права защищены",
      artist: "Художник",
      followMe: "Следуйте за мной"
    },
    // Shop (Haute Galerie)
    shop: {
      title: "Галерея высокого искусства",
      subtitle: "112 оригинальных работ: роскошное художественное вложение",
      searchPlaceholder: "Поиск работы...",
      filterByCollection: "Фильтр по коллекции",
      allCollections: "Все коллекции",
      sortBy: "Сортировать по",
      priceAsc: "Цена: возрастание",
      priceDesc: "Цена: убывание",
      titleAsc: "Название: A-Z",
      titleDesc: "Название: Z-A",
      noResults: "Работы не найдены",
      dimensions: "Размеры",
      price: "Цена",
      technique: "Техника",
      legalMention: "Акрил на холсте, поставляется без подрамника и рамы",
      copyright: "© Георг Эско - Воспроизведение запрещено",
      secureShipping: "Безопасная доставка",
      certificateOfAuthenticity: "Сертификат подлинности",
      acquisitionButton: "Войти во владение этой работой",
      hoverToZoom: "Наведите для увеличения",
      artworksCount: "работы",
      viewCollection: "Посмотреть коллекцию",
      backToCollections: "Вернуться к коллекциям",
      artworkDetails: "Детали работы",
      contactFormTitle: "Запрос на приобретение",
      yourName: "Ваше имя",
      yourEmail: "Ваш email",
      yourMessage: "Ваше сообщение",
      interestedIn: "Заинтересован в",
      sendRequest: "Отправить запрос",
      requestSending: "Отправка...",
      requestSuccess: "Запрос успешно отправлен!",
      requestError: "Ошибка при отправке. Попробуйте еще раз.",
      closeModal: "Закрыть",
      contactArtist: "Пожалуйста, свяжитесь с художником напрямую"
    },
    // Techniques
    techniques: {
      paintingOnCanvas: "Живопись на холсте",
      oilAndAcrylicOnCanvas: "Масло и акрил на холсте"
    },
    // Copyright
    copyright: {
      paintingBy: "Картина Георга Эско",
      uniqueWork: "Уникальная работа",
      copyrightNotice: "© Георг Эско - Воспроизведение запрещено"
    }
  }
};

export const languages = [
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
  { code: 'ja', name: '日本語', flag: '🇯🇵' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'ro', name: 'Română', flag: '🇷🇴' },
  { code: 'ar', name: 'العربية', flag: '🇦🇪' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' }
];
